define((require) => {
    "use strict";

    var ImprovedView            = require("editor/zbone/ImprovedView");

    /**
     * A parent view for all the setting pages.
     *
     * @class SettingView
     * @constructor
     *
     * @cfg {Model} model The CompanySetting model.
     */
    return ImprovedView.extend({

        className: "pt-page settings",

        regions: {
            defaultFooterRegion: ".default-footer"
        },

        // Configure the animation for the setting page
        transitions: {
            "in": "pt-page-scaleUp",
            "out": "pt-page-scaleDown"
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/SettingsView.js